<app-basic-card>
    <!-- @if (isPolicyPrevidenziale && tableValues?.length) {
      <app-basic-table class="w-100" [dataset]="tableValues" [tableKeys]="tableKeys"></app-basic-table>
    } -->
    <app-basic-form [form]="form" [keys]="keys"></app-basic-form>
    <div class="d-flex justify-content-start">
        <button mat-button color="warn" [disabled]="isReadOnly" (click)="reset()">{{'reset' | uppercase}}</button>
    </div>
</app-basic-card>
